// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Profile themes supported by the system
 */
export enum ProfileTheme {
    None = 'none',
    Dark = 'dark',
    Light = 'light',
    HighContrastDark = 'hc-dark',
    HighContrastLight = 'hc-light',
}

function getThemeSuffix(theme: ProfileTheme): string {
    switch (theme) {
        case ProfileTheme.None:
            return '';
        case ProfileTheme.Dark:
            return '-dark';
        case ProfileTheme.Light:
            return '-light';
        case ProfileTheme.HighContrastDark:
            return '-hc-dark';
        case ProfileTheme.HighContrastLight:
            return '-hc-light';
    }
}

/**
 * Course metadata provides a base name for the profile  (e.g. 'tutorial', 'web', etc.)
 * This function returns the name of the profile file based on the theme provided, which
 * can be used to retrieve the profile file from the content cdn.
 * @param profileBaseName base name of the profile provided in the course metadata
 * @param theme theme of the profile
 * @returns Name of the profile file based on the theme
 */
export function getProfileFileName(profileBaseName: string, theme: ProfileTheme) {
    return `${profileBaseName}${getThemeSuffix(theme)}`;
}
